module.exports = __webpack_public_path__ + "media/images/default/pages/business_cooperation/main/6-e6acae7545b160475508ee1f07ad6ddd.svg";